<template>
  <div>
    <page-header>
      <el-input style="width: 200px;margin-right: 12px"/>
      <el-button type="primary" icon="el-icon-search" circle/>
    </page-header>
    <table-union-pager :data="tableData">
      <el-table-column label="订单号" prop="orderNo"/>
      <el-table-column label="用户">
        <template #default="scope">
          <span v-if="!scope.row.userPhone">未注册</span>
          <div v-else>
            <div>{{ scope.row.userName }}</div>
            <div>{{ scope.row.userPhone }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下单时间" prop="orderTime"/>
      <el-table-column label="支付时间" prop="payTime"/>
      <el-table-column label="支付金额" prop="amount"/>
      <el-table-column label="产生积分" prop="points"/>
      <el-table-column label="用户返利" prop="userRebate"/>
      <el-table-column label="邀请商户">
        <template #default="scope">
          <el-button type="text" v-if="scope.row.rebateMerchantName">{{ scope.row.rebateMerchantName }}</el-button>
          <div v-else style="font-style: italic;color: #888888">(无)</div>
        </template>
      </el-table-column>
      <el-table-column label="邀请商户返利">
        <template #default="scope">
          <div>{{ scope.row.merchantRebate }}元</div>
        </template>
      </el-table-column>
      <el-table-column label="邀请员工">
        <template #default="scope">
          <div v-if="scope.row.rebateClerkName">{{ scope.row.rebateClerkName }}</div>
          <div v-else style="font-style: italic;color: #888888">(无)</div>
        </template>
      </el-table-column>
      <el-table-column label="邀请员工返利">
        <template #default="scope">
          <div>{{ scope.row.clerkRebate }}元</div>
        </template>
      </el-table-column>
    </table-union-pager>
  </div>
</template>

<script>
import TableUnionPager from "@/components/TableUnionPager";
import PageHeader from "@/components/PageHeader";

export default {
  name: "Orders",
  components: {PageHeader, TableUnionPager},
  data() {
    return {
      tableData: {
        list: [],
        totalCount: 0,
        page: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    getOrderList(page) {
      this.tableData.list.push({
        userName: '李四',
        userPhone: '13899999999',
        orderTime: '2022-12-12 13:55:58',
        payTime: '2022-12-12 13:56:06',
        orderNo: 'DD1112312329403',
        amount: '38.00',
        userRebate: '0.03',
        merchantRebate: '0.03',
        rebateMerchantName: '达康药店',
        clerkRebate: '0.03',
        rebateClerkName: '张三',
        points: '38',
      });
      this.tableData.list.push({
        userName: null,
        userPhone: null,
        orderTime: '2022-12-12 13:55:58',
        payTime: '2022-12-12 13:56:06',
        orderNo: 'DD1112312329403',
        amount: '38.00',
        userRebate: '0.00',
        merchantRebate: '0.00',
        rebateMerchantName: null,
        clerkRebate: '0.00',
        rebateClerkName: null,
        points: '38'
      });
    }
  },
  mounted() {
    this.getOrderList(1);
  }
}
</script>

<style scoped>

</style>
